module.exports = __webpack_public_path__ + "static/media/Icons_mocktest.70597b6e.svg";